import '../dash.css';
const Dashboardv2 = () => {
  // Inventory metrics data
  const inventoryMetrics = [
    {
      id: 'totalItems',
      title: 'Total Items',
      value: '1,247',
      icon: 'boxes',
      tooltip: 'Total number of inventory items in stock',
      color: 'primary'
    },
    {
      id: 'lowStock',
      title: 'Low Stock Items',
      value: '23',
      icon: 'exclamation-triangle',
      tooltip: 'Items running low and need reordering',
      color: 'warning'
    },
    {
      id: 'outOfStock',
      title: 'Out of Stock',
      value: '8',
      icon: 'times-circle',
      tooltip: 'Items currently out of stock',
      color: 'danger'
    },
    {
      id: 'categories',
      title: 'Categories',
      value: '15',
      icon: 'tags',
      tooltip: 'Total inventory categories',
      color: 'info'
    },
    {
      id: 'monthlyUsage',
      title: 'Monthly Usage',
      value: '₹84,520',
      icon: 'rupee-sign',
      tooltip: 'Total inventory value used this month',
      color: 'success'
    },
    {
      id: 'wastage',
      title: 'Wastage Rate',
      value: '2.3%',
      icon: 'trash',
      tooltip: 'Percentage of inventory wasted this month',
      color: 'secondary'
    }
  ];
  const MetricCard = ({ metric, isLast }) => (
    <div className={`col-lg border-end-lg border-bottom border-bottom-lg-0 border-primary ${isLast ? 'pt-3 pt-lg-0' : 'py-3 py-lg-0'}`}>
      <div className="d-flex flex-between-center mb-3">
        <div className="d-flex align-items-center">
          <div className={`icon-item icon-item-sm bg-${metric.color}-subtle shadow-none me-2`}>
            <span className={`fs--2 fas fa-${metric.icon} text-${metric.color}`}></span>
          </div>
          <h6 className="mb-0 mono-card-text">{metric.title}</h6>
        </div>
        <span className="text-500" data-bs-toggle="tooltip" data-bs-placement="top" aria-label={metric.tooltip} data-bs-original-title={metric.tooltip}>
          <span className="fas fa-info-circle" data-fa-transform="shrink-1"></span>
        </span>
      </div>
      <div className="d-flex ms-3 gap-1">
        <div className={`font-sans-serif lh-1 mb-0 fs-2 pe-2 ${metric.color === 'danger' ? 'text-danger' : ''} ${metric.color === 'warning' ? 'text-warning' : ''}`} id={`Today${metric.id}`}>
          {metric.value}
        </div>
      </div>
    </div>
  );
  // Card data configuration for better maintainability card Box
  const cardData = [
    {
      id: 1,
      title: 'Requisition',
      value: 36,
      color: 'warning',
      icon: '📋',
      bgImage: 'https://rksk.in/public/assets/img/icons/spot-illustrations/corner-7.png'
    },
    {
      id: 2,
      title: 'Purchase Order',
      value: 24,
      color: 'primary',
      icon: '📄',
      bgImage: 'https://rksk.in/public/assets/img/icons/spot-illustrations/corner-7.png'
    },
    {
      id: 3,
      title: 'Total Items',
      value: 156,
      color: 'success',
      icon: '📦',
      bgImage: 'https://rksk.in/public/assets/img/icons/spot-illustrations/corner-7.png'
    },
    {
      id: 4,
      title: 'Amount Purchase',
      value: '₹1.2M',
      color: 'info',
      icon: '💰',
      bgImage: 'https://rksk.in/public/assets/img/icons/spot-illustrations/corner-7.png'
    },
    {
      id: 5,
      title: 'Kitchen Project',
      value: '20',
      color: 'warning',
      icon: '📦',
      bgImage: 'https://rksk.in/public/assets/img/icons/spot-illustrations/corner-7.png'
    }
  ];
  const colorClasses = {
    warning: 'text-warning',
    primary: 'text-primary',
    success: 'text-success',
    info: 'text-info'
  };
  const StatCard = ({ title, value, color, icon, bgImage }) => {
    return (
      <div className="col col mb-3">
        <div className="card statistic-card h-100 border-0 shadow-sm hover-lift">
          <div
            className="bg-holder bg-card opacity-10"
            style={{ backgroundImage: `url('${bgImage}')` }}
          ></div>

          <div className="card-body position-relative">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <h6 className="card-title text-muted mb-0 small fw-semibold text-uppercase">
                {title}
              </h6>
              <span className="fs-5">{icon}</span>
            </div>
            <div className="d-flex align-items-end justify-content-between">
              <div>
                <div className={`display-2  fs-2 fw-bold font-sans-serif ${colorClasses[color]}`}>
                  {value}
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-transparent border-0 pt-0">
            <div className="progress" style={{ height: '4px' }}>
              <div
                className={`progress-bar bg-${color}`}
                style={{ width: '75%' }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const stockAlerts = [
    { id: 1, item: "Tomatoes", category: "Vegetables", currentStock: 5, minStock: 10, status: "Low" },
    { id: 2, item: "Chicken Breast", category: "Meat", currentStock: 0, minStock: 5, status: "Out" },
    { id: 3, item: "Olive Oil", category: "Oils", currentStock: 2, minStock: 5, status: "Low" },
  ];

  const recentActivities = [
    {
      action: "Stock Added",
      description: "Tomatoes (50kg)",
      time: "2 hours ago",
      type: "add",
      icon: "arrow-down",
      quantity: "+50kg"
    },
    {
      action: "Stock Used",
      description: "Chicken Breast (10kg)",
      time: "4 hours ago",
      type: "use",
      icon: "arrow-up",
      quantity: "-10kg"
    },
    {
      action: "Low Stock Alert",
      description: "Olive Oil",
      time: "6 hours ago",
      type: "alert",
      icon: "bell"
    },
    {
      action: "New Item Added",
      description: "Fresh Basil",
      time: "1 day ago",
      type: "new",
      icon: "plus"
    }
  ];


  const today = new Date();

  const todaysetdate = today.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).replace(",", "");


  return (
    <div className="content">
      <div className="container-fluid">

        {/* FILTER SECTION */}
        <div className="card mb-3">
          <div className="card-header border-info">
            <form>
              <div className="row g-3">
                <div className="col-lg-3">
                  <select className="form-control">
                    <option value="">All Categories</option>
                    <option value="vegetables">Vegetables</option>
                    <option value="meat">Meat & Poultry</option>
                    <option value="dairy">Dairy</option>
                    <option value="grains">Grains</option>
                    <option value="spices">Spices</option>
                  </select>
                </div>

                <div className="col-lg-2">
                  <select className="form-control">
                    <option value="">All Status</option>
                    <option value="in-stock">In Stock</option>
                    <option value="low-stock">Low Stock</option>
                    <option value="out-of-stock">Out of Stock</option>
                  </select>
                </div>

                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                  />
                </div>

                <div className="col-lg-2">
                  <input
                    type="date"
                    className="form-control"
                  />
                </div>

                <div className="col-lg-2">
                  <button
                    type="button"
                    className="btn btn-primary w-100"
                  >
                    Search
                  </button>
                </div>

                <div className="col-lg-1">
                  <button
                    type="button"
                    className="btn btn-dark w-100"
                  >
                    Reset
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        {/* MAIN CARD BOX */}
        <div class="row g-3 mb-3">
          {cardData.map(card => (
            <StatCard
              key={card.id}
              title={card.title}
              value={card.value}
              color={card.color}
              icon={card.icon}
              bgImage={card.bgImage}
            />
          ))}
        </div>
        {/* MAIN INVENTORY OVERVIEW */}
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="card border-primary">
              <div className="card-header bg-primary text-white p-2 rounded-top">
                <div className="col-sm-auto d-flex align-items-center">
                  <span className="fa-stack me-2">
                    <i className="fas fa-circle fa-stack-2x text-300"></i>
                    <i className="fa-inverse fa-stack-1x text-primary fas fa-boxes"></i>
                  </span>
                  <div>
                    <h6 className="mb-0 fs-0 text-white">Inventory Overview - Today -{todaysetdate}</h6>
                  </div>
                  <h6 className="fs--1 mb-0 ms-auto pe-2 text-white">
                  </h6>
                </div>
              </div>
              <div className="card-body">
                <div className="row">
                  {inventoryMetrics.map((metric, index) => (
                    <MetricCard
                      key={metric.id}
                      metric={metric}
                      isLast={index === inventoryMetrics.length - 1}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* STOCK ALERTS AND RECENT ACTIVITY */}
        <div className="row">
          {/* Stock Alerts */}
          <div className="col-lg-6 mb-4">
            <div className="card stock-alerts-card border-0 shadow-sm h-100">
              <div className="card-header bg-gradient-primary text-white p-3 rounded-top-3">
                <div className="d-flex align-items-center">
                  <span className="fas fa-exclamation-triangle me-2 fs-2"></span>
                  <h5 className="mb-0 fw-semibold text-white">Stock Alerts</h5>
                  <span className="badge bg-white text-primary ms-2">{stockAlerts.length}</span>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table table-hover mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="ps-3">Item</th>
                        <th>Category</th>
                        <th>Current</th>
                        <th>Min</th>
                        <th className="pe-3">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {stockAlerts.slice(0, 5).map(alert => (
                        <tr key={alert.id} className="align-middle">
                          <td className="ps-3">
                            <div className="d-flex align-items-center">
                              <div className={`status-indicator me-2 bg-${alert.status === 'Out' ? 'danger' : 'warning'}`}></div>
                              <span className="fw-medium">{alert.item}</span>
                            </div>
                          </td>
                          <td>
                            <span className="text-muted">{alert.category}</span>
                          </td>
                          <td>
                            <span className={`fw-bold ${alert.currentStock === 0 ? 'text-danger' : 'text-warning'}`}>
                              {alert.currentStock}
                            </span>
                          </td>
                          <td>
                            <span className="text-muted">{alert.minStock}</span>
                          </td>
                          <td className="pe-3">
                            <span className={`badge badge-${alert.status === 'Out' ? 'danger' : 'warning'} rounded-pill px-2 py-1`}>
                              {alert.status === 'Out' ? 'Out of Stock' : 'Low Stock'}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {stockAlerts.length === 0 && (
                  <div className="text-center py-4">
                    <span className="fas fa-check-circle text-success fs-1 mb-2"></span>
                    <p className="text-muted mb-0">All items are well stocked</p>
                  </div>
                )}
              </div>
              <div className="card-footer bg-transparent border-top-0 pt-0">
                <div className="d-flex justify-content-between align-items-center">
                  <small className="text-muted">
                    Showing {Math.min(stockAlerts.length, 5)} of {stockAlerts.length} alerts
                  </small>
                  <button className="btn btn-sm btn-outline-primary rounded-pill px-3">
                    View All Alerts
                    <span className="fas fa-chevron-right ms-1 small"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Activity */}
          <div className="col-lg-6 mb-4">
            <div className="card recent-activity-card border-0 shadow-sm h-100">
              <div className="card-header bg-gradient-info text-white p-3 rounded-top-3">
                <div className="d-flex align-items-center">
                  <span className="fas fa-history me-2 fs-2"></span>
                  <h5 className="mb-0 fw-semibold text-white">Recent Activity</h5>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="activity-timeline">
                  {recentActivities.map((activity, index) => (
                    <div key={index} className="activity-item d-flex position-relative p-3">
                      <div className="activity-icon me-3">
                        <div className={`icon-circle bg-${activity.type === 'add' ? 'success' : activity.type === 'use' ? 'danger' : activity.type === 'alert' ? 'warning' : 'primary'}-subtle`}>
                          <span className={`fas fa-${activity.icon} text-${activity.type === 'add' ? 'success' : activity.type === 'use' ? 'danger' : activity.type === 'alert' ? 'warning' : 'primary'}`}></span>
                        </div>
                        {index < recentActivities.length - 1 && <div className="timeline-connector"></div>}
                      </div>
                      <div className="activity-content flex-grow-1">
                        <div className="d-flex justify-content-between align-items-start mb-1">
                          <span className="fw-medium">{activity.action}</span>
                          <small className="text-muted">{activity.time}</small>
                        </div>
                        <p className="text-muted mb-0 small">{activity.description}</p>
                        {activity.quantity && (
                          <div className="mt-1">
                            <span className={`badge bg-${activity.type === 'add' ? 'success' : 'danger'}-subtle text-${activity.type === 'add' ? 'success' : 'danger'} rounded-pill`}>
                              {activity.quantity}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                {recentActivities.length === 0 && (
                  <div className="text-center py-4">
                    <span className="fas fa-inbox text-muted fs-1 mb-2"></span>
                    <p className="text-muted mb-0">No recent activity</p>
                  </div>
                )}
              </div>
              <div className="card-footer bg-transparent border-top-0">
                <div className="text-end">
                  <button className="btn btn-sm btn-outline-info rounded-pill px-3">
                    View Full History
                    <span className="fas fa-chevron-right ms-1 small"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Dashboardv2;